import { createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../app/api";
import { serializeError } from "../../app/shared";
import { FullBuildingModel } from "./mapDeviceSlice";

const SLICE_NAME = "mapDeviceList";

export const requestAllDevicesByLocationId = createAsyncThunk(
  `${SLICE_NAME}/get-all`,
  async (locationId: number, { rejectWithValue }) => {
    try {
      const { structure }: { structure: FullBuildingModel[] } = await request.get(`/device/location/${locationId}/all`);
      return structure;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);